// Time-slots admin API fetcher — Wave E.

import { apiClient } from './client';
import { endpoints } from './endpoints';
import type {
  CreateTimeSlotInput,
  TimeSlotDto,
  TimeSlotListResponse,
  UpdateTimeSlotInput,
} from '../types/api';

export async function listTimeSlots(
  type: 'weekday' | 'weekend',
): Promise<TimeSlotDto[]> {
  const res = await apiClient.get<TimeSlotListResponse>(endpoints.timeSlots.list(type));
  return res.data.items;
}

export async function createTimeSlot(input: CreateTimeSlotInput): Promise<TimeSlotDto> {
  const res = await apiClient.post<TimeSlotDto, CreateTimeSlotInput>(
    endpoints.timeSlots.create,
    input,
  );
  return res.data;
}

export async function updateTimeSlot(
  id: number,
  input: UpdateTimeSlotInput,
): Promise<TimeSlotDto> {
  const res = await apiClient.patch<TimeSlotDto, UpdateTimeSlotInput>(
    endpoints.timeSlots.update(id),
    input,
  );
  return res.data;
}

export async function deleteTimeSlot(id: number): Promise<void> {
  await apiClient.delete(endpoints.timeSlots.delete(id));
}
